import Splide from '@splidejs/splide';
import A11yDialog from 'a11y-dialog';
import { hideOthers, inertOthers, supportsInert } from 'aria-hidden';
import A11yMenu from './_a11yMenu';
import Share from './_share';
import FormValidate from './_formValidate';
import FormWithSteps from './_formWithSteps';
import Disclosure from './_disclosure';
import StudyRegister from './_studyRegister';
import ManageGoToTop from './_goToTop';
import InteractiveMap from './_map';
import InputCompteur from './_inputCompteur';
import UpdateData from './_updateData';

import ComboboxAutocomplete from './_combobox-autocomplete';

/*global my_ajax_object*/

import {
	OverlayScrollbars,
	ScrollbarsHidingPlugin,
	SizeObserverPlugin
} from 'overlayscrollbars';


function initProfilUpdate() {
	const blocks = document.querySelectorAll('.dataUpdateWrapper');

	blocks.forEach((elt) => {
		const block = new UpdateData(elt);
		block.init();
	});
}

function initDisclo() {
	// Disclosure
	const disclos = document.querySelectorAll('.disclosure .js-disclo-trigger');

	disclos.forEach((btn) => {
		const discloItem = new Disclosure(btn);
		discloItem.init();
	});
}

function initCombobox() {
	let comboboxes = document.querySelectorAll('.combobox-list');

	for (const element of comboboxes) {
		let combobox = element;
		let comboboxNode = combobox.querySelector('input');
		let buttonNode = combobox.querySelector('button');
		let listboxNode = combobox.querySelector('[role="listbox"]');
		let combo = new ComboboxAutocomplete(comboboxNode, buttonNode, listboxNode);
		combo.init();
	}
}

function initRappel() {
	let rappels = document.querySelectorAll('.js-close-rappel');
	if (rappels) {
		rappels.forEach((elt) => {
			const parent = elt.parentElement.parentElement.parentElement;
			const nextElement = parent.nextElementSibling;

			elt.addEventListener('click', () => {
				nextElement.setAttribute('tabindex', '-1');
				parent.remove();
				nextElement.focus();
			});
		});
	}
}

function returnFileSize(number) {
	if (number < 1e3) {
		return `${number} bytes`;
	} else if (number >= 1e3 && number < 1e6) {
		return `${(number / 1e3).toFixed(1)} KB`;
	} else {
		return `${(number / 1e6).toFixed(1)} MB`;
	}
}

document.addEventListener('DOMContentLoaded', () => {

	document.body.classList.remove('no-js');
	document.body.classList.add('js');

	// Menu
	const a11yMenus = document.querySelectorAll('.a11y-nav-wrapper');
	a11yMenus.forEach((menu) => {
		const a11yMenuItem = new A11yMenu(menu, "72em");
		a11yMenuItem.init();
	});


	// Scroll vers les études filtrées à l'affichage.
	const pathname = window.location.pathname;
	if (pathname.includes("/t/")) {
		const resultDiv = document.querySelector('.js-nb-results');
		if (resultDiv) {
			setTimeout(() => {
				resultDiv.scrollIntoView();
			}, 200);
			setTimeout(() => {
				resultDiv.focus();
			}, 300);
		}
	}


	ManageGoToTop();

	initRappel();


	// scrollbars js-scrollbar
	const scrolls = document.querySelectorAll('.js-scrollbar');
	if (scrolls) {
		OverlayScrollbars.plugin([SizeObserverPlugin, ScrollbarsHidingPlugin]);
		scrolls.forEach((elt) => {
			OverlayScrollbars(elt, {
				scrollbars: {
					theme: 'os-theme-dark',
					visibility: 'visible'
				}
			});
		});
	}

	document.querySelectorAll('.js-go-to-steps-inscription').forEach((button) => {
		button.addEventListener('click', (e) => {
			window.location = e.target.dataset.permalink;
		});
	});

	document.querySelectorAll('.js-connect-2').forEach((button) => {
		button.addEventListener('click', (e) => {
			window.location = e.target.dataset.permalink;
		});
	});

	document.querySelectorAll('.js-redirect-button').forEach((button) => {
		button.addEventListener('click', (e) => {
			window.location = e.target.dataset.permalink;
		});
	});

	initCombobox();

	// Etude inscription

	const container = document.querySelector('#study_modale');
	if (container) {
		const studyController = new StudyRegister(container);
		studyController.init();
	}


	initDisclo();

	const summary__link = document.querySelectorAll('.summary__link');
	summary__link.forEach((link) => {
		link.addEventListener("click", (e) => {
			const currentLink = document.querySelectorAll('.summary__link.current');
			currentLink.forEach((elt) => { elt.classList.remove("current"); });
			e.target.classList.add("current");
		});
	});


	// MARK: compteur
	const compteurs = document.querySelectorAll('.js-max-char');
	compteurs.forEach((elt) => {
		new InputCompteur(elt);
	});

	// MARK: Shares
	const shares = document.querySelectorAll(".share-button-partial, .js-share");
	shares.forEach((btn) => {
		new Share(btn);
	});


	// MARK: Sliders
	const slides = document.querySelectorAll('.js-default-slide');
	slides.forEach((elt) => {
		new Splide(elt, {
			pagination: false,
			perPage: 3,
			gap: '30px',
			breakpoints: {
				1024: {
					perPage: 2
				},
				640: {
					perPage: 1
				}
			}
		}).mount();
	});

	const slides_sidebar = document.querySelectorAll('.js-side-slide');
	slides_sidebar.forEach((elt) => {
		new Splide(elt, {
			pagination: false,
			perPage: 2,
			gap: '30px',
			breakpoints: {
				1200: {
					perPage: 1
				},
				798: {
					perPage: 2
				},
				640: {
					perPage: 1
				}
			}
		}).mount();
	});

	const slides_portraits = document.querySelectorAll('.js-portrait-slide');
	slides_portraits.forEach((elt) => {
		new Splide(elt, {
			pagination: false,
			perPage: 1,
			gap: '30px',
			padding: { right: '20%' },
			breakpoints: {
				1280: {
					padding: { right: '10%' },
				},
				1024: {
					gap: '16px',
					padding: { right: 0 },
				},
				925: {
					gap: '16px',
					padding: { right: '10%' },
				},
				480: {
					gap: '16px',
					padding: { right: '15%' },
				},
				400: {
					gap: '16px',
					padding: { right: 0 },
				}
			}
		}).mount();
	});




	const slides_portraits_controlled = document.querySelector('.js-portrait-slide-controlled');
	if (slides_portraits_controlled) {

		const controlled_slide = new Splide(slides_portraits_controlled, {
			pagination: false,
			perPage: 1,
			gap: '30px',
			padding: { right: '20%' },
			breakpoints: {
				1280: {
					padding: { right: '20%' },
				},
				1024: {
					padding: { right: '20%' },
				},
				980: {
					gap: '16px',
					padding: { right: '10%' },
				},
				870: {
					gap: '16px',
					padding: { right: 0 },
				},
				480: {
					gap: '16px',
					padding: { right: '15%' },
				},
				400: {
					gap: '16px',
					padding: { right: 0 },
				}
			}
		});

		const slides_portraits_controllers = document.getElementsByClassName('js-go-to-portrait-slide');
		let current;

		for (let i = 0; i < slides_portraits_controllers.length; i++) {
			initControllers(slides_portraits_controllers[i], i);
		}

		function initControllers(button, index) {
			button.addEventListener('click', function () {
				controlled_slide.go(index);
			});
		}

		controlled_slide.on('mounted move', function () {
			let button = slides_portraits_controllers[controlled_slide.index];

			if (button) {
				if (current) {
					current.classList.remove('is-active');
				}

				button.classList.add('is-active');
				current = button;
			}
		});

		controlled_slide.mount();

	};


	function getElementRect(el, lockWidth = true, lockHeight = true) {

		const clone = el.cloneNode(true);
		clone.style.cssText = 'position:fixed;top:0;left:0;overflow:auto;visibility:hidden;pointer-events:none;width:unset;min-width:unset;max-width:unset;height:unset;min-height:unset;max-height:unset;'
		if (lockWidth || lockHeight) {
			const { width, height } = el.getBoundingClientRect();
			if (lockWidth) clone.style.cssText += `width:${width}px;`;
			if (lockHeight) clone.style.cssText += `height:${height}px;`;
		}
		document.body.append(clone);
		const rect = clone.getBoundingClientRect();
		clone.remove();
		return rect;
	};

	// Masonry Portraits
	function resizeGridItem(item) {
		const grid = document.getElementsByClassName("masonry-grid")[0];
		const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
		const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
		const rowSpan = Math.ceil((getElementRect(item.querySelector('.card-portrait')).height + rowGap) / (rowHeight + rowGap));
		item.style.gridRowEnd = "span " + rowSpan;
	}

	function resizeAllGridItems() {
		const allItems = document.getElementsByClassName("masonry-grid__item");

		for (const element of allItems) {
			resizeGridItem(element);
		}
	}

	const portraits = document.querySelector('.js-portraits-masonry-grid');

	if (portraits !== null) {

		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (!mutation.target.hasAttribute("hidden")) {
					resizeAllGridItems();
				}
			});
		});
		observer.observe(portraits, { attributes: true, childList: true, subtree: true });


		if ('ResizeObserver' in window) {
			new ResizeObserver(() => {
				resizeAllGridItems();
			}).observe(portraits);
		}
	}


	// MARK: Map

	const map = document.querySelector("#interactive-map");
	if (map) {
		const mapController = new InteractiveMap(map);
		mapController.init();
	}

	// MARK: Toggle password

	const togglePass = document.querySelectorAll('.js-toggle-password');
	togglePass.forEach((elt) => {
		elt.addEventListener('click', (e) => {
			const input = e.target.parentElement.querySelector('input');
			let pressed = e.target.getAttribute('aria-pressed') === 'true';

			// changing input type
			if (!pressed) {
				input.setAttribute("type", "text");
				e.target.setAttribute("title", "Masquer le mot de passe");
			} else {
				input.setAttribute("type", "password");
				e.target.setAttribute("title", "Afficher le mot de passe");
			}

			e.target.setAttribute('aria-pressed', String(!pressed));
		});
	});

	// MARK: Forms steps


	if (document.querySelector('.js-inscription-steps-form')) {
		const stepsForm = new FormWithSteps(document.querySelector('.js-inscription-steps-form'));
		stepsForm.init();
	}


	// MARK: Connexion with credentials
	const connect_creds = document.querySelector('.js-connect-creds');
	if (connect_creds) {

		new FormValidate(connect_creds, 'mono-field');
		connect_creds.addEventListener('validated', () => {

			const action = connect_creds.dataset.action;
			const ajaxurl = connect_creds.dataset.ajaxurl;
			const nonce = connect_creds.dataset.nonce;

			const redirectUrl = connect_creds.querySelector('#redirect').value;

			const data = new FormData(connect_creds);
			data.append('action', action);
			data.append('nonce', nonce);

			const ms = document.querySelector('.form__status');
			ms.innerHTML = "Traitement en cours";
			fetch(ajaxurl, {
				method: 'POST',
				body: data,
			})
				.then(response => response.json())
				.then(response => {

					connect_creds.querySelector('.submitButton').classList.remove('loading');

					ms.innerHTML = "";

					if (response.success) {

						const p = document.createElement('p');
						p.classList.add("alert", "alert--success");
						p.innerHTML = response.data;
						document.querySelector('.formResultMessage').appendChild(p);
						document.querySelector('.formResultMessage').focus();

						setTimeout(() => {
							window.location = redirectUrl;
						}, 1000);

					} else {

						const p = document.createElement('p');
						p.classList.add("alert", "alert--error");
						p.innerHTML = response.data;
						document.querySelector('.formErrorMessage ').appendChild(p);
						document.querySelector('.formErrorMessage ').focus();

					}

				})
				.catch((error) => {
					connect_creds.querySelector('.submitButton').classList.remove('loading');
					const p = document.createElement('p');
					p.classList.add("alert", "alert--error");
					p.innerHTML = error
					document.querySelector('.formErrorMessage').appendChild(p);
					document.querySelector('.formErrorMessage').focus();
				});


		});
	}

	// MARK: INSCRIPTION DEPUIS ETUDE
	const inscription_study = document.querySelector('.js-inscription_study');
	if (inscription_study) {
		new FormValidate(inscription_study, 'mono-field');
		inscription_study.addEventListener('validated', () => {

			const action = inscription_study.dataset.action;
			const ajaxurl = inscription_study.dataset.ajaxurl;
			const nonce = inscription_study.dataset.nonce;

			const data = new FormData(inscription_study);
			data.append('action', action);
			data.append('nonce', nonce);

			const ms = document.querySelector('.form__status');
			ms.innerHTML = "Traitement en cours";


			fetch(ajaxurl, {
				method: 'POST',
				body: data,
			})
				.then(response => response.json())
				.then(response => {

					if (inscription_study.querySelector('.submitButton')) {
						inscription_study.querySelector('.submitButton').classList.remove('loading');
					}
					ms.innerHTML = "";

					if (response.success) {

						// Modification step 4 texte with seintinelle email
						const toModifyText = document.querySelector('.form-step__result').innerHTML;

						let newText = toModifyText.replaceAll("[EMAIL]", document.getElementById('account.email').value);

						document.querySelector('.form-step__result').innerHTML = newText;

						// redirect vers page confirmation
						document.querySelector('.form-step.active').remove();
						document.getElementById('validation-step').removeAttribute('hidden');

					} else {

						const p = document.createElement('p');
						p.classList.add("alert", "alert--error");
						p.innerHTML = response.data;


						document.querySelector('.formErrorMessage ').appendChild(p);
						document.querySelector('.formErrorMessage ').focus();
					}

				})
				.catch((error) => {

					if (inscription_study.querySelector('.submitButton')) {
						inscription_study.querySelector('.submitButton').classList.remove('loading');
					}
					const p = document.createElement('p');
					p.classList.add("alert", "alert--error");
					p.innerHTML = error;
					document.querySelector('.formErrorMessage').appendChild(p);
					document.querySelector('.formErrorMessage').focus();
				});

		});
	}


	// MARK: FORM CONTACT

	const forms = document.querySelectorAll('.js-forms-validate');
	forms.forEach((form) => {
		new FormValidate(form, 'unique');
		form.addEventListener('validated', () => {
			const action = form.dataset.action;
			const ajaxurl = form.dataset.ajaxurl;
			const nonce = form.dataset.nonce;

			const data = new FormData(form);
			data.append('action', action);
			data.append('nonce', nonce);

			const ms = form.querySelector('.form__status');
			ms.innerHTML = "Traitement en cours...";

			fetch(ajaxurl, {
				method: 'POST',
				body: data,
			})
				.then(response => response.json())
				.then(response => {

					form.querySelector('.submitButton').classList.remove('loading');

					ms.innerHTML = "";

					if (response.success) {

						const p = document.createElement('p');
						p.classList.add("alert", "alert--success");
						p.innerHTML = response.data;
						form.querySelector('.formResultMessage').appendChild(p);
						form.querySelector('.formResultMessage').focus();

					} else {

						const p = document.createElement('p');
						p.classList.add("alert", "alert--error");
						p.innerHTML = response.data;
						form.querySelector('.formErrorMessage ').appendChild(p);
						form.querySelector('.formErrorMessage ').focus();

					}

				})
				.catch((error) => {

					form.querySelector('.submitButton').classList.remove('loading');

					const p = document.createElement('p');
					p.classList.add("alert", "alert--error");
					p.innerHTML = error
					form.querySelector('.formErrorMessage').appendChild(p);
					form.querySelector('.formErrorMessage').focus();
				});
		});
	});


	// MARK: FORMS WEBINAR

	const webinar_inscription_form = document.querySelector(".webinar__inscriptionForm");
	if (webinar_inscription_form) {
		new FormValidate(webinar_inscription_form, 'mono-field');
		webinar_inscription_form.addEventListener('validated', () => {

			const action = webinar_inscription_form.dataset.action;
			const ajaxurl = webinar_inscription_form.dataset.ajaxurl;
			const nonce = webinar_inscription_form.dataset.nonce;
			const idwebinar = webinar_inscription_form.dataset.idwebinar;

			const data = new FormData(webinar_inscription_form);

			data.append('action', action);
			data.append('nonce', nonce);
			data.append('idwebinar', idwebinar);

			const ms = document.querySelector('.form__status');
			ms.innerHTML = "Traitement en cours";

			fetch(ajaxurl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Cache-Control': 'no-cache',
				},
				body: new URLSearchParams(data),
			})
				.then(response => response.json())
				.then(body => {

					webinar_inscription_form.querySelector('.submitButton').classList.remove('loading');
					ms.innerHTML = "";

					const result_div = document.createElement('div');
					const result_p = document.createElement('p');
					result_p.innerHTML = body.data;
					result_div.append(result_p);

					if (body.success) {
						document.querySelector('.webinar__inscriptionForm__fields').remove();
						document.querySelector('.formResultMessage').appendChild(result_div);
						document.querySelector('.formResultMessage').focus();
					} else {
						document.querySelector('.formErrorMessage').appendChild(result_div);
						document.querySelector('.formErrorMessage').focus();
					}

				});
		});
	}

	// MARK: Spokerperson
	const spokerpersonInput = document.querySelector('.js-update-spoker');

	if (spokerpersonInput) {
		const formMedia = document.querySelector('.js-form-media');
		let isMediaLoading = false;

		spokerpersonInput.addEventListener('change', function () {
			if (isMediaLoading) {
				return false;
			}
			isMediaLoading = true;

			formMedia.querySelector('.formResultMessage').innerHTML = "";
			formMedia.querySelector('.formErrorMessage').innerHTML = "";

			const action = "update_spokesperson";
			const ajaxurl = my_ajax_object.ajax_url;
			const nonce = my_ajax_object.nonce;

			const data = new FormData(formMedia);
			data.append('action', action);
			data.append('nonce', nonce);

			fetch(ajaxurl, {
				method: 'POST',
				body: new URLSearchParams(data),
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Cache-Control': 'no-cache',
				},
			})
				.then(response => response.json())
				.then(body => {

					const result_div = document.createElement('div');
					const result_p = document.createElement('p');
					result_p.innerHTML = body.data;
					result_div.append(result_p);

					if (body.success) {
						formMedia.querySelector('.formResultMessage').appendChild(result_div);
						formMedia.querySelector('.formResultMessage').focus();
					} else {
						formMedia.querySelector('.formErrorMessage').appendChild(result_div);
						formMedia.querySelector('.formErrorMessage').focus();
					}

					isMediaLoading = false;
				})
				.catch(error => {
					console.log('There was an error', error);
					isMediaLoading = false;
				});

		});
	}


	// MARK: Likes

	const likeBtns = document.querySelectorAll('.js-add-like');
	let isLikeLoading = false;

	likeBtns.forEach((likeBtn) => {

		const updateField = likeBtn.querySelector('.js-nb-likes-updates');
		const resultSpan = likeBtn.querySelector('.js-nb-likes');

		likeBtn.addEventListener('click', () => {

			if (isLikeLoading) {
				return false;
			}

			isLikeLoading = true;
			updateField.innerHTML = "";

			const pageID = likeBtn.dataset.id;
			const action = "add_like";
			const ajaxurl = my_ajax_object.ajax_url;
			const nonce = my_ajax_object.nonce;

			const data = {
				action: action,
				nonce: nonce,
				pageid: pageID
			};

			fetch(ajaxurl, {
				method: 'POST',
				body: new URLSearchParams(data),
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Cache-Control': 'no-cache',
				},
			})
				.then(response => response.json())
				.then(body => {

					if (body.success) {
						resultSpan.innerHTML = body.data;
						updateField.innerHTML = `${body.data} personnes aiment ce contenu`;
					}

					isLikeLoading = false;
				})
				.catch(error => {
					console.log('There was an error', error);
					isLikeLoading = false;
				});

		});
	});

	// Mark: Comments
	const openCommentDialogButtons = document.querySelectorAll('.js-add-comment');
	const commentModale = document.querySelector('#comment_modale');
	let registered = false;

	if (commentModale) {

		const commentDialog = new A11yDialog(commentModale);

		commentDialog.on('show', function () {

			let focusOnElement = "";
			if (supportsInert()) {
				focusOnElement = inertOthers(commentModale);
			} else {
				focusOnElement = hideOthers(commentModale);
			}

			if (!registered) {
				commentDialog.on('hide', focusOnElement);
				registered = true
			}

		});

		openCommentDialogButtons.forEach((openCommentDialogButton) => {
			openCommentDialogButton.addEventListener('click', () => {
				commentDialog.show();
			});

		});

		if (window.location.hash === "#commentaire") {
			commentDialog.show();
		}

	}

	//MARK: Testimony ANCHOR
	const openTestimonyDialogButtons = document.querySelectorAll('.js-add-testimony');

	if (window.location.hash && window.location.hash === '#temoigner') {
		const btn = openTestimonyDialogButtons[0];
		if (btn && btn.closest('.tabpanel')) {
			const tab = btn.closest('.tabpanel');
			const buttonTab = document.querySelector(`#${tab.getAttribute('aria-labelledby')}`);
			if (buttonTab) {
				buttonTab.click();
			}
		}
	}

	// MARK: Testimony
	const testimony_modale = document.querySelector('#testimony_modale');
	let testimony_registered = false;

	if (testimony_modale) {

		const testimonyDialog = new A11yDialog(testimony_modale);

		testimonyDialog.on('show', function () {

			let focusOnElement = "";
			if (supportsInert()) {
				focusOnElement = inertOthers(testimony_modale);
			} else {
				focusOnElement = hideOthers(testimony_modale);
			}

			if (!testimony_registered) {
				testimonyDialog.on('hide', focusOnElement);
				testimony_registered = true
			}

		});

		openTestimonyDialogButtons.forEach((openTestimonyDialogButton) => {
			openTestimonyDialogButton.addEventListener('click', () => {
				testimonyDialog.show();
			});

		});

		if (window.location.hash === "#temoigner") {
			testimonyDialog.show();
		}

	}



	// MARK: Portrait

	const portraitPictureHandler = document.querySelector('.js-handle-photo-upload');
	if (portraitPictureHandler) {

		const previewBlock = portraitPictureHandler.querySelector('.js-portrait-preview');
		const fileInput = portraitPictureHandler.querySelector('.js-file-upload-input');

		if (!fileInput) return false;

		const acceptFormats = fileInput.getAttribute('accept').replace(/\s/g, '').split(',');
		const maxSize = fileInput.dataset.maxsize;

		fileInput.addEventListener('change', (e) => {

			// reset
			portraitPictureHandler.querySelector('.file-upload-error').innerHTML = "";
			fileInput.setAttribute('aria-invalid', false);

			if (!e.target.files.length) {
				previewBlock.innerHTML = "";
				previewBlock.classList.remove("with-preview");
			} else {
				const file = e.target.files[0];

				// Validation format
				if (!acceptFormats.includes(file.type)) {
					const err = document.createElement('div');
					err.classList.add('indiError');
					err.innerHTML = `Ce format d'image n'est pas accepté.`;
					portraitPictureHandler.querySelector('.file-upload-error').appendChild(err);
					fileInput.setAttribute('aria-invalid', true);
					return false;
				}

				// Validation taille
				if (file.size > maxSize) {

					const err = document.createElement('div');
					err.classList.add('indiError');
					err.innerHTML = `Le fichier ne doit pas dépasser : ${returnFileSize(maxSize)}`;
					portraitPictureHandler.querySelector('.file-upload-error').appendChild(err);
					fileInput.setAttribute('aria-invalid', true);
					return false;

				}

				previewBlock.classList.add("with-preview");
				previewBlock.innerHTML = `<img src="${URL.createObjectURL(file)}" alt="${file.name}" >`;
			}

		});

	}

	const portraitForm = document.querySelector('.edit-portrait-form');
	const saveForNowButton = document.querySelector('.js-save-for-now');
	const publishButton = document.querySelector('.js-publish');

	if (portraitForm && saveForNowButton) {
		saveForNowButton.addEventListener('click', () => {

			if (saveForNowButton.classList.contains('loading')) return;
			// prevent new submit
			saveForNowButton.classList.add('loading');



			const action = "save_portrait_draft";
			const ajaxurl = my_ajax_object.ajax_url;
			const nonce = my_ajax_object.nonce;

			const data = new FormData(portraitForm);
			data.append('action', action);
			data.append('nonce', nonce);

			const ms = document.querySelector('.form__status');
			ms.innerHTML = "Traitement en cours";
			document.querySelector('.formResultMessage').innerHTML = "";
			document.querySelector('.formErrorMessage').innerHTML = "";


			fetch(ajaxurl, {
				method: 'POST',
				body: data,
				headers: {
					'Cache-Control': 'no-cache',
				},
			})
				.then(response => response.json())
				.then(body => {
					ms.innerHTML = "";
					saveForNowButton.classList.remove('loading');

					const result_div = document.createElement('div');
					const result_p = document.createElement('p');

					if (body.data.message) {
						result_p.innerHTML = body.data.message;
					} else {
						result_p.innerHTML = body.data;
					}
					result_div.append(result_p);

					if (body.success) {
						document.querySelector('#page_id').setAttribute('value', body.data.id_portrait);
						document.querySelector('.formResultMessage').appendChild(result_div);
						document.querySelector('.formResultMessage').focus();
					} else {
						document.querySelector('.formErrorMessage').appendChild(result_div);
						document.querySelector('.formErrorMessage').focus();
					}
				});

		});
	}

	// MARK: Portrait save
	if (portraitForm && publishButton) {
		publishButton.addEventListener('click', (e) => {
			e.preventDefault();

			if (publishButton.classList.contains('loading')) return;
			// prevent new submit
			publishButton.classList.add('loading');

			const testimonial = portraitForm.querySelector('#testimonial');
			const fileInput = portraitForm.querySelector('.js-file-upload-input');


			// Reset
			let ifOk = true;
			document.querySelector('.formResultMessage').innerHTML = "";
			document.querySelector('.formErrorMessage').innerHTML = "";
			document.querySelectorAll('.indiError').forEach((err) => {
				err.remove();
			});



			if (testimonial.value.length <= 0) {

				testimonial.setAttribute('aria-invalid', true);

				const err = document.createElement('div');
				const errorId = `error_${testimonial.getAttribute('name')}`;
				err.classList.add('indiError');
				err.id = errorId;
				err.innerHTML = `Veuillez remplir votre présentation.`;
				testimonial.after(err);
				testimonial.setAttribute('aria-describedby', `${errorId} #${testimonial.dataset.describedby}`);

				ifOk = false;
			} else {

				testimonial.setAttribute('aria-invalid', false);
				testimonial.setAttribute('aria-describedby', `# ${testimonial.dataset.describedby}`);

			}

			if (!portraitForm.querySelector('.js-portrait-preview').classList.contains('with-preview')
				&& portraitForm.querySelector('.js-file-upload-input').files.length == 0) {

				const err = document.createElement('div');
				err.classList.add('indiError');
				err.innerHTML = `Veuillez ajouter votre photo.`;
				portraitForm.querySelector('.file-upload-error').appendChild(err);
				fileInput.setAttribute('aria-invalid', true);

				ifOk = false;
			} else {
				portraitForm.querySelector('.file-upload-error').innerHTML = "";
				fileInput.setAttribute('aria-invalid', false);
			}

			if (!ifOk) {

				//focus sur le premier input faux
				const firstInvalidField = portraitForm.querySelector('[aria-invalid=true]');
				if (firstInvalidField) {
					firstInvalidField.focus();
				}

				publishButton.classList.remove('loading');

			} else {
				// on envoit. 

				const action = "save_portrait";
				const ajaxurl = my_ajax_object.ajax_url;
				const nonce = my_ajax_object.nonce;

				const data = new FormData(portraitForm);
				data.append('action', action);
				data.append('nonce', nonce);

				const ms = document.querySelector('.form__status');
				ms.innerHTML = "Traitement en cours";

				fetch(ajaxurl, {
					method: 'POST',
					body: data,
					headers: {
						'Cache-Control': 'no-cache',
					},
				})
					.then(response => response.json())
					.then(body => {
						ms.innerHTML = "";
						publishButton.classList.remove('loading');

						const result_div = document.createElement('div');
						const result_p = document.createElement('p');
						result_p.innerHTML = body.data;
						result_div.append(result_p);

						if (body.success) {
							document.querySelector('.formResultMessage').appendChild(result_div);
							document.querySelector('.formResultMessage').focus();

							document.querySelector('.portrait__saveButtons').remove();

						} else {
							document.querySelector('.formErrorMessage').appendChild(result_div);
							document.querySelector('.formErrorMessage').focus();
						}
					});

			}


			return false;
		});
	}


	// MARK: profil

	initProfilUpdate();

	const profilButtons = document.querySelectorAll('.js-go-to-profil-section');
	profilButtons.forEach((btn) => {
		btn.addEventListener('click', () => {
			if (btn.getAttribute('aria-pressed') === 'true') return false;
			const section = document.querySelector(`#${btn.dataset.section}`);
			const oldBtn = document.querySelector('.js-go-to-profil-section[aria-pressed=true]');
			const oldSection = document.querySelector(`#${oldBtn.dataset.section}`);

			oldBtn.setAttribute('aria-pressed', false);
			oldSection.setAttribute('hidden', '');

			btn.setAttribute('aria-pressed', true);
			section.removeAttribute('hidden');
			section.focus();

		});
	});

	//MARK: TIMELINE


	const timelineSection = document.querySelector('.js-fetch-timeline');

	function handleError(err) {
		console.log('ohhh noooo');
		console.log(err);
		const loader = document.querySelector('.timelineLoadingMessage');
		loader.innerHTML = `Désolé, nous n'avons pas pu récupéré votre historique :<br><br>${err}`;
	}

	async function fetchTimelineData() {

		const action = "get_timeline";
		const ajaxurl = my_ajax_object.ajax_url;
		const nonce = my_ajax_object.nonce;

		const data = {
			action: action,
			nonce: nonce,
		};

		const res = await fetch(ajaxurl, {
			method: 'POST',
			body: new URLSearchParams(data),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'private',
			},
		});
		const result = await res.json();
		return result;
	}

	async function handleTimelineData() {
		const response = await fetchTimelineData();
		const loader = document.querySelector('.timelineLoadingMessage');
		if (response.success) {
			if (response.data.length <= 0) {
				loader.textContent = `Désolé, il semble que votre historique soit vide pour l'instant.`;
			} else {
				loader.classList.add("visually-hidden");
				loader.textContent = "Chargement de l'historique complété."
				timelineSection.innerHTML = response.data;
			}
		} else {
			loader.innerHTML = `Désolé, nous n'avons pas pu récupéré votre historique :<br><br>${response.data}`;
		}
	}


	if (timelineSection) {
		handleTimelineData().catch(handleError);
	}

});